// Chemin: C:\gestion-copro\src\types\lot.types.ts

import { Timestamp } from 'firebase/firestore';

/**
 * Types de lots dans une copropriété
 */
export type TypeLot = 
  | 'appartement' 
  | 'studio' 
  | 'parking' 
  | 'parking_couvert'
  | 'parking_exterieur'
  | 'cave' 
  | 'local_velo'
  | 'local_commercial' 
  | 'bureau' 
  | 'autre';

/**
 * Propriétaire d'un lot (ancien modèle embarqué - conservé pour rétrocompatibilité)
 * @deprecated Utiliser proprietaireId pour lier à un Coproprietaire
 */
export interface Proprietaire {
  nom: string;
  prenom?: string;
  email?: string;
  telephone?: string;
  adresseCorrespondance?: string;
  userId?: string;
}

/**
 * Entité Lot
 * Représente un lot privatif dans la copropriété
 */
export interface Lot {
  id: string;
  coproprieteId: string;
  
  // Identification
  numero: string;
  type: TypeLot;
  batiment?: string;
  etage?: string;
  description?: string;
  
  // Rattachement à un lot principal (appartement)
  // Si renseigné, ce lot est un lot secondaire (cave, parking, local vélo)
  lotPrincipalId?: string;
  
  // Tantièmes
  tantièmesGeneraux: number;
  tantièmesSpeciaux?: {
    ascenseur?: number;
    chauffage?: number;
    parking?: number;
    espaceVert?: number;
  };
  
  // Propriétaire - NOUVEAU : lien vers la collection Coproprietaires
  proprietaireId?: string;
  
  // Propriétaire actuel (ancien modèle embarqué - conservé pour rétrocompatibilité)
  proprietaire: Proprietaire;
  
  // Métadonnées
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

/**
 * Données pour création
 */
export interface LotCreateData {
  coproprieteId: string;
  numero: string;
  type: TypeLot;
  batiment?: string;
  etage?: string;
  description?: string;
  lotPrincipalId?: string;
  proprietaireId?: string;
  tantièmesGeneraux: number;
  tantièmesSpeciaux?: {
    ascenseur?: number;
    chauffage?: number;
    parking?: number;
    espaceVert?: number;
  };
  proprietaire: Proprietaire;
}

/**
 * Données pour mise à jour
 */
export interface LotUpdateData {
  numero?: string;
  type?: TypeLot;
  batiment?: string;
  etage?: string;
  description?: string;
  lotPrincipalId?: string | null; // null pour détacher
  proprietaireId?: string | null; // null pour délier du copropriétaire
  tantièmesGeneraux?: number;
  tantièmesSpeciaux?: {
    ascenseur?: number;
    chauffage?: number;
    parking?: number;
    espaceVert?: number;
  };
  proprietaire?: Partial<Proprietaire>;
}

/**
 * Labels pour l'affichage
 */
export const TYPE_LOT_LABELS: Record<TypeLot, string> = {
  appartement: 'Appartement',
  studio: 'Studio',
  parking: 'Parking',
  parking_couvert: 'Parking couvert',
  parking_exterieur: 'Parking extérieur',
  cave: 'Cave',
  local_velo: 'Local vélo',
  local_commercial: 'Local commercial',
  bureau: 'Bureau',
  autre: 'Autre'
};

/**
 * Types considérés comme lots principaux (affichés dans le tableau)
 */
export const TYPES_LOT_PRINCIPAL: TypeLot[] = ['appartement', 'studio'];

/**
 * Types considérés comme lots secondaires (rattachables)
 */
export const TYPES_LOT_SECONDAIRE: TypeLot[] = [
  'parking', 
  'parking_couvert', 
  'parking_exterieur', 
  'cave', 
  'local_velo', 
  'autre'
];

/**
 * Pour l'affichage condensé d'un lot
 */
export interface LotResume {
  id: string;
  numero: string;
  type: TypeLot;
  proprietaireNom: string;
  tantièmesGeneraux: number;
}